import { render, staticRenderFns } from "./chemicalBorrow.vue?vue&type=template&id=0bc060b4&scoped=true"
import script from "./chemicalBorrow.vue?vue&type=script&lang=js"
export * from "./chemicalBorrow.vue?vue&type=script&lang=js"
import style0 from "./chemicalBorrow.vue?vue&type=style&index=0&id=0bc060b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc060b4",
  null
  
)

export default component.exports